import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import type * as React from 'react'

type ReasonTooltipProps = Pick<React.ComponentProps<typeof TooltipContent>, 'side' | 'sideOffset'> & {
	/** Without one the children render bare. */
	reason?: React.ReactNode
	/** Merged onto the wrapping span, which is `inline-flex` by default. */
	className?: string
	children: React.ReactNode
}

/** A disabled control swallows its own hover, so the tooltip hangs off a span around it. */
export function ReasonTooltip({ reason, className, side, sideOffset, children }: ReasonTooltipProps) {
	if (!reason) {
		return <>{children}</>
	}
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className={cn('inline-flex', className)}>{children}</span>
			</TooltipTrigger>
			<TooltipContent side={side} sideOffset={sideOffset}>
				{reason}
			</TooltipContent>
		</Tooltip>
	)
}
